module.exports = __webpack_public_path__ + "src/img/bigger.4c6cfa47.svg";